export const TRIGGER = "TRIGGER";
export const CLEAR_TRIGGER = "CLEAR_TRIGGER";
